import React from 'react'
import './signIn.css'
import { NavLink } from 'react-router-dom';
import Footer from '../../component/footer/footer'
import { Row, Col, Input, Button, Checkbox } from 'antd';
import logo from '../../assets/img/logo.svg'
import loginlogo from '../../assets/img/user.svg'
import discordlogo from '../../assets/img/discord.svg'

const Login = () => {

    return(
        <div>
            <div className="login_banner">
            
                <div className="login_banner_header">

                    <div className="logo">
                        <ul>
                            <NavLink exact to="/" >
                                <li><img src={logo} alt=""/></li>
                            </NavLink>
                        </ul>
                    </div>
                
                </div>
                
                <div className="login_banner_form">
                    <Row gutter={[16, 24]} className="login_form_row" >
                        <Col className="gutter-row login_form_holder" xs = {{ span: 24 }} sm = {{ span: 16 }} md = {{ span: 12 }} lg = {{ span: 10 }} xl ={{ span: 8 }}>
                            
                            <div className="login_logo">
                                <img src={loginlogo} alt=""/>
                                <h4>Sign In</h4>
                                <p>Sign in to join Games online.</p>
                            </div>

                            <div className="login_inputs">
                                <Input placeholder="Username or email" />
                                <Input.Password placeholder="Password" />
                                <NavLink exact to="/user-home">
                                    <Button type="primary">Sign In</Button>
                                </NavLink>
                            </div>

                            <div className="login_form_kmsi">
                                <ul>
                                    <li>
                                        <Checkbox>Keep me signed in</Checkbox>
                                    </li>
                                    <NavLink exact to="/forgot-password" >
                                        <li>Forgot password?</li>
                                    </NavLink>
                                </ul>
                            </div>

                            <div className="login_footer">
                                <ul>
                                    <li><img src={discordlogo} alt=""/> Login with Discord</li>
                                </ul>
                                <ul>
                                <NavLink exact to="/sign-up" >
                                    <li>New to PlayarOne? <span>Sign up today.</span></li>
                                </NavLink>
                                </ul>
                            </div>
                        
                        </Col>
                    </Row>
                </div>
            
            </div>

            <Footer />
        </div>
    );
}

export default Login;